'use client'

import { getCachedSession } from '@/shared/api/client-api'
import { API_URL, methods } from '@/shared/api/constants'
import { API_END_POINTS } from '@/shared/api/end-points'
import { CreateHypothesisRecommendationsParams } from '@/shared/api/end-points/hypothesis'

type CreateHypothesisRecommendationsDto = {
  request: string
}

const createRecommendations = async (
  dto: CreateHypothesisRecommendationsDto,
  params: CreateHypothesisRecommendationsParams,
) => {
  try {
    const session = await getCachedSession()
    const token = session?.user?.token

    if (!API_URL) return null

    const endpointPath = API_END_POINTS.hypothesis.createRecommendations(params).replace(/^\/+/, '')
    const requestUrl = new URL(endpointPath, API_URL.endsWith('/') ? API_URL : `${API_URL}/`).toString()

    await fetch(requestUrl, {
      method: methods.post,
      cache: 'no-cache',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dto),
    })
  } catch {
    return null
  }

  return null
}

export default createRecommendations
